// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** Report (actions). */
const icon: IconData = {
  id: "flag",
  name: "Report",
  category: "actions",
  styles: {
    rounded: {
      svg: '<path d="M7 14V20Q7 20.42 6.71 20.71T6 21 5.29 20.71 5 20V5Q5 4.58 5.29 4.29T6 4H13.17Q13.52 4 13.79 4.23T14.14 4.8L14.4 6H19Q19.42 6 19.71 6.29T20 7V15Q20 15.42 19.71 15.71T19 16H13.83Q13.48 16 13.21 15.77T12.86 15.2L12.6 14Z"/>',
    },
    sharp: { svg: '<path d="M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21Z"/>' },
    outline: {
      svg: '<path d="M7 14V20Q7 20.42 6.71 20.71T6 21 5.29 20.71 5 20V5Q5 4.58 5.29 4.29T6 4H13.17Q13.52 4 13.79 4.23T14.14 4.8L14.4 6H19Q19.42 6 19.71 6.29T20 7V15Q20 15.42 19.71 15.71T19 16H13.83Q13.48 16 13.21 15.77T12.86 15.2L12.6 14ZM14.65 14H18V8H13.58Q13.23 8 12.96 7.77T12.6 7.2L12.35 6H7V12H13.42Q13.77 12 14.04 12.23T14.39 12.8ZM12.5 10"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M13.5 4.06L13.79 4.23 14.01 4.49 14.14 4.8 14.4 6H19L19.39 6.07 19.71 6.29 19.93 6.61 20 7V15L19.93 15.39 19.71 15.71 19.39 15.93 19 16H13.83L13.5 15.94 13.21 15.77 12.99 15.51 12.86 15.2 12.6 14H7V20L6.93 20.39 6.71 20.71 6.39 20.93 6 21 5.61 20.93 5.29 20.71 5.07 20.39 5 20V5L5.07 4.61 5.29 4.29 5.61 4.07 6 4H13.17Z"/></g><path d="M7 14V20Q7 20.42 6.71 20.71T6 21 5.29 20.71 5 20V5Q5 4.58 5.29 4.29T6 4H13.17Q13.52 4 13.79 4.23T14.14 4.8L14.4 6H19Q19.42 6 19.71 6.29T20 7V15Q20 15.42 19.71 15.71T19 16H13.83Q13.48 16 13.21 15.77T12.86 15.2L12.6 14ZM14.65 14H18V8H13.58Q13.23 8 12.96 7.77T12.6 7.2L12.35 6H7V12H13.42Q13.77 12 14.04 12.23T14.39 12.8ZM12.5 10"/>',
    },
  },
  animation: () => import("../animations/flag.js"),
};

export default icon;
